module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"
  }), _vm._v(" "), (_vm.showNewsfeed) ? _c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet"
  }, [_c('welcome-message'), _vm._v(" "), _c('list-filter', {
    on: {
      "update": function($event) {
        _vm.updateNewsfeed($event)
      },
      "progress": function($event) {
        _vm.showProgress = $event
      }
    }
  }), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }]
  }), _vm._v(" "), (_vm.newsfeed.length === 0) ? [_c('empty-newsfeed', {
    on: {
      "refresh": function($event) {
        _vm.getNewsfeed()
      }
    }
  })] : _vm._l((_vm.newsfeed), function(data) {
    return _c('list', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.showProgress),
        expression: "!showProgress"
      }],
      key: data.fecha,
      attrs: {
        "data": data
      },
      on: {
        "showReport": function($event) {
          _vm.showReport($event)
        }
      }
    })
  })], 2) : _c('div', {
    staticClass: "mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet"
  }, [_c('audit-report', {
    attrs: {
      "audit": _vm.clickedAudit
    },
    on: {
      "showProgress": function($event) {
        _vm.showProgress2 = $event
      },
      "showNewsfeed": function($event) {
        _vm.showNewsfeed = $event
      }
    }
  }), _vm._v(" "), _c('progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress2),
      expression: "showProgress2"
    }]
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b86baaa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Roles/Auditor/Newsfeed/index.vue
// module id = 238
// module chunks = 0